import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { marketingHtmlLang, parseLocaleFromPath } from '#marketing/lib/marketing-locale.js';

/**
 * Keep i18n and `<html lang>` in sync with the URL on client-side navigations.
 */
export function MarketingLocaleSync() {
  const { pathname } = useLocation();
  const { locale } = parseLocaleFromPath(pathname);
  const htmlLang = marketingHtmlLang(locale);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
    document.documentElement.lang = htmlLang;
  }, [locale, htmlLang, i18n, pathname]);

  return null;
}
